import type { ExperienceItem } from '@/types/abtest'
import { pushConvertActionToDatalayer, pushConvertExperimentsToDataLayer } from '@/utils/abtest'

export const useConvertExperiments = () => {
  const authStore = useAuthStore()
  const variationsCookie = useCookie<ExperienceItem[]>('ota-conv-ab')
  const visitorIdCookie = useCookie('ota-conv-context')

  const pushCurrentVisitorExperimentToDataLayer = (experienceKey: string) => {
    const experiences = variationsCookie.value || []
    const visitorId = visitorIdCookie.value || ''

    if (!visitorId) {
      return
    }

    // Find the specific experience matching the experienceKey
    const matchingExperience = experiences.find((experience) => experience?.experienceKey === experienceKey)

    if (!matchingExperience) {
      return
    }

    // Push only the matching experience
    pushConvertExperimentsToDataLayer([matchingExperience], visitorId)
  }

  const pushCurrentVisitorExperimentInteractionToDataLayer = (
    experienceKey: string,
    interaction: string,
    memberId?: string
  ) => {
    const experiences = variationsCookie.value || []
    const visitorId = visitorIdCookie.value || ''
    const userId = authStore.authId || ''

    if (!visitorId) {
      return
    }

    const matchingExperience = experiences.find((experience) => experience?.experienceKey === experienceKey)

    if (!matchingExperience) {
      return
    }

    pushConvertActionToDatalayer(interaction, matchingExperience, `${userId}`, memberId, visitorId)
  }

  return {
    pushCurrentVisitorExperimentToDataLayer,
    pushCurrentVisitorExperimentInteractionToDataLayer
  }
}
